import Lang from "lang.js";
import moment from "moment";

const default_locale = window.default_locale;
const fallback_locale = window.fallback_locale;
const messages = window.messages;

Vue.prototype.trans = new Lang({
    messages: messages,
    locale: default_locale,
    fallback: fallback_locale,
});

const momentLocale = window.momentjs_locale;
moment.locale(momentLocale);
